const createGoogleSearchUrl = (queryParts, isImageSearch = false) => {
  const filteredQueryParts = queryParts.filter(part => part != null && part.trim() !== '');
  const imageParam = isImageSearch ? 'tbm=isch&' : '';

  return `https://www.google.com/search?${imageParam}q=${filteredQueryParts.join(' ')}`;
};

export { createGoogleSearchUrl };
